<template>
    <b-row>
        <b-col sm="12" md="3">
            <b-form-group>
                <label>Número do Contrato</label>
                <b-input-group>
                    <b-form-input
                        type="text"
                        v-model="codigoContrato"
                    ></b-form-input>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-col sm="12" md="4">
            <b-form-group>
                <label>Status da Integração</label>
                <model-list-select
                    :list="statusIntegracaoOpcoes"
                    option-text="descricao"
                    option-value="codigo"
                    v-model="statusIntegracao"
                >
                </model-list-select>
            </b-form-group>
        </b-col>
        <b-col sm="12" md="5">
            <div class="mt-4">
                <b-button
                    variant="primary"
                    class="mt-2 ml-1"
                    @click="pesquisar()"
                    >Filtrar</b-button
                >
                <b-button
                    variant="primary"
                    class="mt-2 ml-2"
                    @click="limparFiltros()"
                    >Limpar Filtros</b-button
                >
            </div>
        </b-col>
    </b-row>
</template>

<script>
import { ModelListSelect } from 'vue-search-select'
import MeEventosServicos from './MeEventosServicos'

export default {
    data() {
        return {
            codigoContrato: null,
            statusIntegracao: null,
            statusIntegracaoOpcoes: []
        }
    },

    components: {
        ModelListSelect
    },

    methods: {
        obterOpcoesFiltros() {
            this.$store.dispatch('addRequest')
            MeEventosServicos.obterOpcoesFiltros().then((response) => {
                if (response) {
                    if (response.success) {
                        this.statusIntegracaoOpcoes = response.data
                            .statusIntegracaoOpcoes
                            ? response.data.statusIntegracaoOpcoes
                            : []
                    } else {
                        this.$emit('erro', response.mensagem)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        pesquisar() {
            this.$emit('pesquisar', {
                codigoContrato: this.codigoContrato,
                statusIntegracao: this.statusIntegracao
            })
        },

        limparFiltros() {
            this.codigoContrato = null
            this.statusIntegracao = null
            this.$emit('pesquisar', {
                codigoContrato: null,
                statusIntegracao: null
            })
        }
    },

    mounted() {
        this.obterOpcoesFiltros()
    }
}
</script>
